import { ComponentProps } from 'react';

export type CodeProps = ComponentProps<'svg'>;

export function Code(props: CodeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      width={926.62165}
      height={600.08495}
      viewBox="0 0 926.62165 600.08495"
      {...props}
    >
      <circle cx={150.53395} cy={254.87249} r={24.56103} fill="#ffb8b8" />
      <path
        fill="#ffb8b8"
        d="M67.543 549.197L73.762 559.763 117.474 540.803 108.295 525.21 67.543 549.197z"
      />
      <path
        d="M69.406 544.472l12.248 20.807a15.386 15.386 0 01-5.455 21.065l-.431.254-20.052-34.067z"
        fill="#2f2e41"
      />
      <path
        fill="#ffb8b8"
        d="M139.6 587.26L151.86 587.259 157.692 539.971 139.598 539.972 139.6 587.26z"
      />
      <path
        d="M136.473 583.257h24.144a15.386 15.386 0 0115.387 15.385v.5l-39.53.002zM90.311 558.61a4.493 4.493 0 01-3.624-1.833l-11.823-16.059a4.5 4.5 0 011.124-6.41l52.614-35.142-31.746-83.474 67.889 5.602 2.286 71.734a36.046 36.046 0 01-18.045 32.423L92.56 558.005a4.486 4.486 0 01-2.249.605z"
        fill="#2f2e41"
      />
      <path
        d="M139.97 577.66a4.5 4.5 0 01-4.489-4.34l-2.488-69.882 30.809-1.623-2.453 70.384a4.487 4.487 0 01-4.2 4.333l-16.873 1.118a4.6 4.6 0 01-.306.01z"
        fill="#2f2e41"
      />
      <path
        d="M172.602 435.171c-7.839 0-35.217-8.816-44.721-11.959-1.422 1.138-9.234 6.979-18.352 5.911-5.626-.66-10.578-3.844-14.72-9.465-9.147-12.415 2.15-65.652 13.239-108.126a34.268 34.268 0 0140.528-24.88 34.571 34.571 0 0126.088 25.378c2.087 8.498.291 18.494-1.02 25.794-.616 3.431-1.103 6.142-.937 7.474.644 5.149 4.219 85.892 1.92 89.34-.245.367-.953.533-2.025.533z"
        fill="#e83675"
      />
      <path
        d="M143.927 435.314a10.743 10.743 0 00.941-16.445l.486-97.844-23.045 3.837 6.77 94.97a10.8 10.8 0 0014.848 15.482z"
        fill="#ffb8b8"
      />
      <path
        d="M149.257 383.86h-24.822a4.514 4.514 0 01-4.5-4.458l-.61-67.292a17.603 17.603 0 1135.205.043l-.773 67.26a4.515 4.515 0 01-4.5 4.448z"
        fill="#e83675"
      />
      <path
        d="M144.28 279.331c-11.245.02-21.854-8.868-23.803-19.943a28.671 28.671 0 01.92-13.014 34.954 34.954 0 0147.935-21.953c3.008 1.362 5.971 3.317 7.349 6.318s.515 7.195-2.498 8.545c-1.97.883-4.44.45-6.187 1.716-2.51 1.82-1.864 5.692-.743 8.581s2.388 6.387.51 8.853c-1.751 2.297-5.25 2.226-8.005 1.361s-5.476-2.313-8.349-2.018c-4.19.43-7.201 4.598-7.759 8.773s.755 8.349 2.05 12.357z"
        fill="#2f2e41"
      />
      <path d="M259 600.085H1a1 1 0 110-2h258a1 1 0 010 2z" fill="#ccc" />
      <path
        d="M910.122 434.548H269.283a16.519 16.519 0 01-16.5-16.5V22.894a12.102 12.102 0 0112.088-12.088h649.454a12.311 12.311 0 0112.297 12.297v394.945a16.519 16.519 0 01-16.5 16.5z"
        fill="#f2f2f2"
      />
      <path
        d="M889.402 413.716H292.157c-8.755 0-15.877-6.67-15.877-14.869V54.742c0-6.08 5.278-11.026 11.765-11.026H893.32c6.595 0 11.96 5.028 11.96 11.208v343.923c0 8.199-7.122 14.869-15.877 14.869z"
        fill="#fff"
      />
      <path
        d="M926.392 24.95h-673.84v-8.4A16.574 16.574 0 01269.112 0h640.72a16.574 16.574 0 0116.56 16.55z"
        fill="#3f3d56"
      />
      <circle cx={282.64694} cy={12.5} r={4.28342} fill="#fff" />
      <circle cx={298.90575} cy={12.5} r={4.28342} fill="#fff" />
      <circle cx={315.16455} cy={12.5} r={4.28342} fill="#fff" />
      <path
        d="M576.61 118.954H459.802a6.566 6.566 0 010-13.132H576.61a6.566 6.566 0 110 13.132zM721.757 118.954H604.949a6.566 6.566 0 010-13.132h116.808a6.566 6.566 0 110 13.132zM721.757 143.837H518.552a6.566 6.566 0 110-13.133h203.205a6.566 6.566 0 110 13.133zM576.61 93.727H459.802a6.566 6.566 0 010-13.133H576.61a6.566 6.566 0 110 13.133zM640.89 94.072h-33.177a6.566 6.566 0 010-13.132h33.177a6.566 6.566 0 110 13.132zM492.979 143.837h-33.177a6.566 6.566 0 010-13.133h33.177a6.566 6.566 0 110 13.133zM576.61 351.954H459.802a6.566 6.566 0 010-13.132H576.61a6.566 6.566 0 110 13.132zM721.757 351.954H604.949a6.566 6.566 0 010-13.132h116.808a6.566 6.566 0 110 13.132zM721.757 376.837H518.552a6.566 6.566 0 110-13.133h203.205a6.566 6.566 0 110 13.133zM576.61 326.727H459.802a6.566 6.566 0 010-13.133H576.61a6.566 6.566 0 110 13.133zM640.89 327.072h-33.177a6.566 6.566 0 010-13.132h33.177a6.566 6.566 0 010 13.132zM492.979 376.837h-33.177a6.566 6.566 0 010-13.133h33.177a6.566 6.566 0 110 13.133z"
        fill="#ccc"
      />
      <path
        d="M546.104 281.462a9.397 9.397 0 01-6.624-2.71l-43.908-43.36a9.152 9.152 0 010-13.023l43.73-43.184a9.702 9.702 0 0113.644.043 9.689 9.689 0 010 13.686l-32.495 32.497a5.413 5.413 0 000 7.646l32.32 32.32a9.418 9.418 0 01-6.667 16.085zM616.07 281.462a9.418 9.418 0 01-6.667-16.084l32.32-32.32a5.413 5.413 0 000-7.647l-32.496-32.497a9.678 9.678 0 010-13.686 9.702 9.702 0 0113.643-.043l43.732 43.184a9.152 9.152 0 010 13.023l-43.91 43.36a9.399 9.399 0 01-6.623 2.71z"
        fill="#e83675"
      />
    </svg>
  );
}
